import React, { useMemo, useCallback } from "react";
import MultiSelectDropdown from "./base/MultiSelectDropdown";

const SelectMultiBoolean = ({ title, selectedValues, setSelectedValues, trueLabel = "app.yes", falseLabel = "app.no" }) => {
  const options = useMemo(
    () => [
      { value: true, label: trueLabel },
      { value: false, label: falseLabel },
    ],
    [trueLabel, falseLabel],
  );

  const handleChange = useCallback(
    (values) => {
      setSelectedValues(values);
    },
    [setSelectedValues],
  );

  return (
    <MultiSelectDropdown
      title={title}
      values={options}
      defaultSelected={selectedValues}
      onChange={handleChange}
    />
  );
};

export default React.memo(SelectMultiBoolean);
